import { SectionType } from '../enums/section-type.enum';

import { AnnouncementBannerModel } from './announcement-banner.model';
import { CarouselSectionModel } from './carousel-section.model';
import { ContactSectionModel } from './contact-section.model';
import { Equal3SectionModel } from './equal-3-section.model';
import { Equal4SectionModel } from './equal-4-section.model';
import { HeroSectionModel } from './hero-section.model';
import { SquareSectionModel } from './square-section.model';
import { StageSectionModel } from './stage-section.model';
import { StaggeredSectionModel } from './staggered-section.model';
import { TestCarSectionModel } from './test-car-section.model';
import { TestRouteSectionModel } from './test-route-section.model';

export interface Section {
  type: SectionType;
  headline?: string;
  anchor?: string;
  items?: any;
  [key: string]: any;
}

// TODO: use section union type
export const createSectionByType = (data: any): Section | null => {
  try {
    switch (data.type) {
      case SectionType.STAGE:
        return new StageSectionModel(data);
      case SectionType.ANNOUNCEMENT:
        return new AnnouncementBannerModel(data);
      case SectionType.HEADLINE:
        return data; // TODO: create headline section model
      case SectionType.HERO:
        return new HeroSectionModel(data);
      case SectionType.EQUAL_3:
        return new Equal3SectionModel(data);
      case SectionType.EQUAL_4:
        return new Equal4SectionModel(data);
      case SectionType.SQUARE:
        return new SquareSectionModel(data);
      case SectionType.STAGGERED:
        return new StaggeredSectionModel(data);
      case SectionType.INFO:
        return data;
      case SectionType.CAROUSEL:
        return new CarouselSectionModel(data);
      case SectionType.TEST_CAR:
        return new TestCarSectionModel(data);
      case SectionType.TEST_ROUTE:
        return new TestRouteSectionModel(data);
      case SectionType.CONTACT:
        return new ContactSectionModel(data);
      default:
        return data;
    }
  } catch (e) {
    console.error('Error while creating section model', e);
    return null;
  }
};
